<template>

<app-input-wrapper :slim="slim" :expand="expand" :note="note" :label="label" :errored="errored" class="toggle" :class="{'is-small': small}">

	<div class="toggle-options">

		<div class="toggle-options-item" v-for="score in max" :key="score" :class="{'is-active': score === value}" v-on:click="onOptionClick(score)">

            <app-icon name="star-o" v-if="value < score" />
            <app-icon name="star" v-if="value >= score" />
            
        </div>

	</div>

</app-input-wrapper>

</template>

<script>

import mixinInput from '@/mixin/input.js'

export default {

	mixins: [mixinInput],

    props: ['small'],
    
    data: function() {

        return {
            max: 5
        }

    },

	methods: {

		onOptionClick: function(value) {

			this.onValueChange((this.value === parseInt(value)) ? 0 : parseInt(value))

		}

	}

}

</script>

<style scoped>

.toggle-options {
	display: flex;
    flex-direction: row;
    height: 40px;
    width: 100%;
    justify-content: flex-end;
}

.toggle.is-small .toggle-options {
    height: 24px;
    justify-content: flex-start;
}

.toggle-options-item {
	font-size: 24px;
	line-height: 40px;
    cursor: pointer;
    color: var(--color-yellow);
	padding: 0px 10px;
}

.toggle.is-small .toggle-options-item {
    font-size: 16px;
    line-height: 24px;
    padding: 0px 4px 0px 0px;
    color: var(--color-blue-light);
}

.is-desktop .toggle-options-item:hover {
    color: var(--color-yellow-dark);
}

.is-desktop .toggle.is-small .toggle-options-item:hover {
    color: var(--color-blue-dark);
}

</style>